import { Plugin } from "ckeditor5/src/core";

import BlockStyleCommand from "./BlockStyleCommand";

export default class BlockStyleEditing extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "BlockStyleEditing";
  }

  constructor(editor) {
    super(editor);

    editor.config.define("blockStyles", {
      options: [
        {
          label: "Normal",
          model: "paragraph",
          validFor: ["item", "passage"],
          view: {
            name: "p",
          },
        },
        {
          label: "Advanced Organizer",
          model: "advancedOrganizer",
          validFor: ["passage"],
          view: {
            classes: "advance_organizer",
            name: "div",
          },
        },
        {
          label: "Block Quote",
          model: "blockQuote",
          validFor: ["item", "passage"],
          view: {
            classes: "pad8-24",
            name: "p",
          },
        },
        {
          label: "Boxed Directions Stem",
          model: "boxedDirectionsStem",
          validFor: ["item"],
          view: {
            classes: "boxed_directions_stem",
            name: "div",
          },
        },
        {
          label: "Boxed Directions Stimulus",
          model: "boxedDirectionsStimulus",
          validFor: ["passage"],
          view: {
            classes: "boxed_directions_stimulus",
            name: "div",
          },
        },
        {
          label: "Chapter Title",
          model: "chapterTitle",
          validFor: ["item", "passage"],
          view: {
            classes: "chapter_title",
            name: "ct",
          },
        },
        {
          label: "Citation",
          model: "citation",
          validFor: ["item", "passage"],
          view: {
            classes: "cite",
            name: "p",
          },
        },
        {
          label: "GAC Solution",
          model: "solution",
          validFor: ["item"],
          view: {
            classes: "solution",
            name: "div",
          },
        },
        {
          label: "Paired Passage Instruction",
          model: "pairedPassageInstruction",
          validFor: ["item"],
          view: {
            classes: "paired_passage_instruction",
            name: "div",
          },
        },
        {
          label: "Prompt",
          model: "prompt",
          validFor: ["item"],
          view: {
            classes: "prompt",
            name: "div",
          },
        },
        {
          label: "Passage Head",
          model: "passageHead",
          validFor: ["passage"],
          view: {
            classes: "passage_head",
            name: "div",
          },
        },
        {
          label: "Passage Note",
          model: "passageNote",
          validFor: ["passage"],
          view: {
            classes: "passage-note",
            name: "p",
          },
        },
        {
          label: "Passage Sub-head",
          model: "passageSubHead",
          validFor: ["passage"],
          view: {
            classes: "passage-sub-head",
            name: "p",
          },
        },
        {
          label: "Stimulus Paragraph Number",
          model: "stimulusParagraphNumber",
          validFor: ["passage"],
          view: {
            classes: "stimulus_paragraph_number",
            name: "p",
          },
        },
        {
          label: "Heading 3",
          model: "heading1",
          validFor: ["item", "passage"],
          view: {
            name: "h3",
          },
        },
        {
          label: "Heading 4",
          model: "heading2",
          validFor: ["item", "passage"],
          view: {
            name: "h4",
          },
        },
        {
          label: "Heading 5",
          model: "heading3",
          validFor: ["item", "passage"],
          view: {
            name: "h5",
          },
        },
      ],
    });
  }

  /**
   * @inheritDoc
   */
  init() {
    this._defineSchema();
    this._defineConverters();

    const editor = this.editor;

    editor.commands.add("setBlockStyle", new BlockStyleCommand(editor));

    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand("setBlockStyle");
    }
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    this.editor.config
      .get("blockStyles.options")
      .filter(
        ({ model }) =>
          ![
            "chapterTitle",
            "heading1",
            "heading2",
            "heading3",
            "paragraph",
          ].includes(model),
      )
      .map(({ model, view }) => {
        schema.register(model, {
          allowContentOf: view.name === "div" ? "$root" : "$block",
          allowIn: "$root",
          isBlock: true,
        });
      });
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    this.editor.config
      .get("blockStyles.options")
      .filter(
        ({ model }) =>
          !["heading1", "heading2", "heading3", "paragraph"].includes(model),
      )
      .map(({ model, view }) => {
        conversion.elementToElement({
          model,
          view,
        });
      });
  }
}
